export const KEY_REDUCER_FEATURED_SEARCH = "featuredSearch";

export const LOADER_ID_FEATURED_SEARCH_SECTIONS = "fs/section";
